import { AccomodationTranslation } from "@models/accomodation-translation.model";
import { Location } from "@models/location.model";


export default function CardSuggestion(props: { cardSuggestionTranslation: AccomodationTranslation | undefined, accomodationLocation: Location | undefined }) {
    if(!props.cardSuggestionTranslation){
        return null
    }
    const { detail, accomodation} = props.cardSuggestionTranslation
   
    return (
        <a href={`https://pwa.hostyble.com/${accomodation?.qrCodeId}`}  rel="noreferrer" target="_blank" className="w-full text-decoration-none text-black">
            <img
                src={`data:image/png;base64,${accomodation?.imgMobile}`}
                alt={accomodation?.name}
            />
            <div className="p-4">
                <h3 className="text-lg font-semibold text-black">{accomodation?.name}</h3>
                {props.accomodationLocation && (
                    <div className="flex items-center text-sm mt-3 mb-2" style={{color: "#A0A0A0"}}>
                        <i className="fa-solid fa-location-dot me-2"></i><span className="fw-bold">{props?.accomodationLocation.city}, {props?.accomodationLocation?.country}</span>
                    </div>
                )}

                <p className="text-gray-600 text-sm leading-relaxed">
                    {detail}
                </p>
            </div>
        </a>
    );

}

